var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"container c-header"},[_c('IdfBreadcrumb',{attrs:{"items":_vm.breadcrumb}}),_c('h1',{staticClass:"idf-font-xl"},[_vm._v(_vm._s(_vm.title))]),(_vm.description)?_c('p',{staticClass:"c-header__description"},[_vm._v(_vm._s(_vm.description))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }